<script lang="ts" generics="ITEM">
    import type {RecordSearchParams} from 'typings/portaro.be.types';
    import {getSearchContext} from '../kp-search-context/search-context';
    import KpSearchBar from 'shared/ui-widgets/search/KpSearchBar.svelte';
    import SearchToolbarSection from './SearchToolbarSection.svelte';

    export let searchType: 'record-name' | 'query';

    const searchManager = getSearchContext<ITEM, RecordSearchParams>();
    const searchManagerState = searchManager.getState$();

    const handleSearch = (event: CustomEvent<string>) => {
        searchManager.newSearchWithPartialParams({
            q: searchType === 'query' ? event.detail : undefined,
            name: searchType === 'record-name' ? event.detail : undefined
        });
    }

    const handleReset = () => {
        searchManager.newSearchWithPartialParams({
            q: searchType === 'query' ? null : undefined,
            name: searchType === 'record-name' ? null : undefined
        });
    }
</script>

<SearchToolbarSection additionalClasses="search-toolbar-searchbar">
    <KpSearchBar placeholder="Hledat mezi daty..."
                 searchQuery={searchType === 'record-name' ? $searchManagerState.frontendParams.name : $searchManagerState.frontendParams.q}
                 buttonColorAccented="{false}"
                 width="100%"
                 height="20px"
                 searchIconSize="12px"
                 resetIconSize="12px"
                 on:search={handleSearch}
                 on:reset={handleReset}/>
</SearchToolbarSection>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    :global {
        .search-toolbar-searchbar .kp-search-bar {
            flex-direction: row-reverse;
            align-items: center;

            .search-input, .submit-button {
                border: none !important;
            }

            .search-input {
                padding: 0 @spacing-s !important;
                padding-right: @spacing-xl !important;
            }

            .submit-button {
                border-radius: @border-radius-default !important;
                width: 16px !important;
                height: 20px !important;

                .uicon {
                    font-size: 12px;
                    color: @themed-text-muted;
                }
            }

            .reset-button {
                right: 0 !important;
            }
        }
    }
</style>